import { useContext, useState, } from 'react';
import { AppBar, Avatar, Box, Button, Container, Fab, Grid, List, ListItem, ListItemAvatar, ListItemText, Paper, Snackbar, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Typography } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Block, Edit } from '@material-ui/icons';

// Context
import AuthContext from '../../context/authContext';
import { getUser, GetUserById, SignupMember } from '../../graphqlCommunication/AuthInterface';
import { DeleteTerm, GetAllTerms, UpdateTerm } from '../../graphqlCommunication/TermsInterface';
import { DeleteLink, UpdateLink } from '../../graphqlCommunication/LinksInterface';
import { GetSettingByIds, UpdateSetting } from '../../graphqlCommunication/SettingsInterface';
import { UpdateGroup } from '../../graphqlCommunication/GroupInterface';
import { Alert, Rating, TabPanel } from '@material-ui/lab';
import PersonIcon from '@material-ui/icons/Person';
import { GetAllFeedback } from '../../graphqlCommunication/FeedbackInterface';
import { FeedbackDialog } from '../feedback/FeedbackDialog';
import { DetailFeedbackDialog } from './DetailFeedbackDialog';
import { HistPlot } from './HistPlot';
import { CountCreations } from './CountCreations';


const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.myDivider.main,
        color: theme.palette.text,
        fontSize: "1rem",
    },
    body: {
        fontSize: "1rem",
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(8),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        background: "lightgray",
        minHeight: '100vh',
        maxWidth: "none",
    },
    appbar: {
        paddingTop: theme.spacing(0),
    },
    tabPanel: {
        paddingTop: theme.spacing(0),
    },
    paper: {
        padding: theme.spacing(2),
        marginTop: theme.spacing(0),
    },
    input: {
        minWidth: 140,
        maxWidth: 180,
    },
    inputMassage: {
        minWidth: 300,
        maxWidth: 600,
    },
    margin: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    text: {
        color: theme.palette.text.main,
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    button: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    buttonTableHead: {
        marginRight: theme.spacing(0),
        marginLeft: theme.spacing(1),
    },
    link: {
        textDecoration: 'none',
        color: theme.palette.text.main,
    },
    fab: {
        background: "none",
        boxShadow: "none",
        color: theme.palette.primary.dark,
    },
    icon: {
        color: theme.palette.primary.dark,
    },
    table: {
        minWidth: 700,
    },

}));

const emptyForm = {
    name: '',
    email: '',
    password: '',
    permission: '',
}





export const SuperAdministration = ({ terms, linkArray, setLinkArray }) => {
    const classes = useStyles();




    // Context
    const contextType = useContext(AuthContext);
    const [feedbackArray, setFeedbackArray] = useState([]);
    const [users, setUsers] = useState([]);
    const [deleteCode, setDeleteCode] = useState("000");
    const [openAlert, setOpenAlert] = useState(false)
    const [addUserRespose, setAddUserRespose] = useState("...")
    const [termArray, setTermArray] = useState([])


    // For Oben an Close the Dialog
    const [anchorEl, setAnchorEl] = useState(null);

    // Get all users of the Group
    const handleGetFeedbacks = () => {
        GetAllFeedback(setFeedbackArray, contextType.token)
    }


    // Get all users of the Group
    const handleGetUsers = () => {
        getUser(setUsers)
    }

    // Get all users of the Group
    const handleGetTerms = () => {
        GetAllTerms(setTermArray, contextType.token)
        console.log(termArray)
        /* termArray.map((termItem) => {
            console.log(termItem.date)
        }) */
    }



    // Update All Terms (Sollte immer verwednet werden wenn neue Attribute hinzugfügt werden)
    const handleUpdateAllTerms = () => {
        termArray.map((termItem) => {
            //console.log("Update:" + termItem.name)
            UpdateTerm(termItem, contextType.token)
            return termItem;
        })
    }


    const handleResetAbbreviation = () => {
        if (deleteCode === "4242") {
            termArray.map((termItem) => {
                //console.log("Update:" + termItem.name)
                termItem.abbreviation = ""
                UpdateTerm(termItem, contextType.token)
                return termItem;
            })
        }
    }

    const handleRemoveAllTerms = () => {
        if (deleteCode === "4242") {
            termArray.map((termItem) => {
                //console.log("Delete:" + termItem.name)
                DeleteTerm(termItem._id, setTermArray, termArray, contextType.token)
                return termItem;
            })
        } else {
            //console.log("Wrong delete code ")
        }
    }

    const handleRemoveAllAutoLinks = () => {
        //console.log("# handleRemoveAllAutoLinks #")
        if (deleteCode === "4242") {
            linkArray.map((linkItem) => {
                if (linkItem.description === "autoLink") {
                    //console.log("Delete:" + linkItem.name)
                    DeleteLink(linkItem._id, setLinkArray, linkArray, contextType.token)
                }
                return linkItem;
            })
        } else {
            //console.log("Wrong delete code ")
        }
    }

    const handleRemoveAllLinks = () => {
        //console.log("# handleRemoveAllLinks #")
        if (deleteCode === "4242") {
            linkArray.map((linkItem) => {
                //console.log("Delete:" + linkItem.name)
                DeleteLink(linkItem._id, setLinkArray, linkArray, contextType.token)
                return linkItem;
            })
        } else {
            //console.log("Wrong delete code ")
        }
    }

    const handleChangeDeleteCode = (event, newValue) => {
        let { value } = event.target;
        setDeleteCode(value);
    };



    // Map all User into the list Items
    const userList = users.map((val, index) => {
        //const key = `listItems-${index}`;
        return (
            <ListItem  >
                <ListItemAvatar>
                    <Avatar>
                        <PersonIcon />
                    </Avatar>
                </ListItemAvatar>

                <ListItemText className={classes.listItem} primary={val.name + " (" + val.email + ")"} secondary={
                    <>
                        <Typography
                            component="span"
                            variant="body2"
                            sx={{ color: 'text.primary', display: 'inline' }}
                        >
                            {"Permission: " + val.permission}
                        </Typography>

                    </>

                } />
                {val.permission === "inactive" && (
                    < Block color="primary" />
                )}
                <span className={classes.listItem} >

                </span>
            </ListItem>
        )
    });



    // Map all User into the list Items
    /*     const feedbackList = feedbackArray.map((val, index) => {
            //const key = `listItems-${index}`;
            return (
                <ListItem  >
                    <ListItemAvatar>
                        <Avatar>
                            <PersonIcon />
                        </Avatar>
                    </ListItemAvatar>
    
                    <ListItemText className={classes.listItem} primary={val.name + " (" + val.description + ")"} secondary={
                        <>
                            <Typography
                                component="span"
                                variant="body2"
                                sx={{ color: 'text.primary', display: 'inline' }}
                            >
                                {"Date: " + val.date}
                            </Typography>
    
                        </>
    
                    } />
                    {val.permission === "inactive" && (
                        < Block color="primary" />
                    )}
                    <span className={classes.listItem} >
    
                    </span>
                </ListItem>
            )
        }); */


    const formatDateString = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Monate sind nullbasiert
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${day}.${month}.${year} - ${hours}:${minutes}:${seconds}`;
    };

    const [currentFeedback, setCurrentFeedback] = useState(null);
    const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
    const handleFeedbackDialogClose = () => {
        setFeedbackDialogOpen(false);
    };

    const handleOpenDetails = (event, updatedFeedback) => {
        console.log("feedback Handle");
        console.log(updatedFeedback);
        setCurrentFeedback(updatedFeedback);
        setFeedbackDialogOpen(true);
    }

    const addJsonObjectToFeedback = (feedback, jsonObject) => {
        feedback.descriptionJson = jsonObject;
        return feedback;
    };

    const tableRows = feedbackArray.map((feedback, setIndex) => {

        if (feedback.description && feedback.description.startsWith("{")) {

            const jsonObject = JSON.parse(feedback.description);
            const updatedFeedback = addJsonObjectToFeedback(feedback, jsonObject);

            const formattedDate = formatDateString(feedback.date);

            if (jsonObject != null) {
                return (
                    <StyledTableRow key={feedback.name + "_" + "_" + Math.random()}>
                        <StyledTableCell align="left">
                            {formattedDate}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                            <Rating
                                id="rating"
                                label="Topic"
                                name="rating"
                                value={jsonObject.rating}
                            />
                        </StyledTableCell>
                        <StyledTableCell align="left">
                            {feedback.name}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                            {jsonObject.feedbackType}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                            {feedback.creator.email}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                            <Button
                                variant="contained"
                                color="red"
                                onClick={event => handleOpenDetails(event, updatedFeedback)}
                                className={classes.button}>
                                Open Details
                            </Button>
                        </StyledTableCell>
                    </StyledTableRow>
                );
            }
        }
    });


    // Snackbar
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    // Tab Bar
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={2}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    ///////////
    // Retun //
    ///////////

    return (
        <Container className={classes.container}>

            <AppBar position="static" className={classes.appbar}>
                <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                    <Tab label="Dash Board" />
                    <Tab label="User Infomratin" />
                    <Tab label="User Feedback" />
                    <Tab label="General Settings" />
                </Tabs>
            </AppBar>

            <TabPanel className={classes.tabPanel} value={value} index={0}>

                {/* Topic */}
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={12} sm={12} style={{ height: '100%' }}>
                        <Paper className={classes.paper}>
                            <Typography className={classes.text} variant="h6">Dash Board</Typography>
                        </Paper>
                    </Grid>
                </Grid>

                {/* Dashboard Items*/}
                <Grid container spacing={3} className={classes.gridContainer}>

                    {/* First Columb */}
                    <Grid item xs={12} sm={6} style={{ height: '100%' }}>
                        <Paper className={classes.paper}>
                            <Typography className={classes.text} variant="h6">Current Term</Typography>

                            <Box className={classes.list}>

                                <HistPlot termArray={termArray} /> 
                            </Box>
                            <Button variant="contained" color="primary" onClick={handleGetTerms} className={classes.button}>Get Data</Button>
                        </Paper>
                    </Grid>

                    {/* Second Columb */}
                    <Grid item xs={12} sm={6} style={{ height: '100%' }}>
                        <Paper className={classes.paper}>
                            <Typography className={classes.text} variant="h6">Count Creations</Typography>                          

                            <Box className={classes.list}>
                                <CountCreations termArray={termArray} /> 
                            </Box>
                            <Button variant="contained" color="primary" onClick={handleGetTerms} className={classes.button}>Get Data</Button>
                        </Paper>
                    </Grid>
                </Grid>
            </TabPanel>


            <TabPanel className={classes.tabPanel} value={value} index={1}>
                <Paper className={classes.paper}>
                    <Typography className={classes.text} variant="h6">Current User</Typography>

                    <Box className={classes.list}>
                        <List>{userList}</List>
                    </Box>
                    <Button variant="contained" color="primary" onClick={handleGetUsers} className={classes.button}>Get Users</Button>
                </Paper>
            </TabPanel>

            <TabPanel className={classes.tabPanel} value={value} index={2}>
                <Paper className={classes.paper}>
                    <Typography className={classes.text} variant="h6">Current Feedback</Typography>
                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="parameter settings table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="left">Date</StyledTableCell>
                                    <StyledTableCell align="left">Rating</StyledTableCell>
                                    <StyledTableCell align="left">Topic</StyledTableCell>
                                    <StyledTableCell align="left">Type</StyledTableCell>
                                    <StyledTableCell align="left">User</StyledTableCell>
                                    {/*                                 <StyledTableCell align="left">General Feedback</StyledTableCell>
                                <StyledTableCell align="left">Navigation</StyledTableCell>
                                <StyledTableCell align="left">Add New</StyledTableCell>
                                <StyledTableCell align="left">Link Analysis</StyledTableCell>
                                <StyledTableCell align="left">Import</StyledTableCell>
                                <StyledTableCell align="left">Administration</StyledTableCell> */}
                                    <StyledTableCell align="left">Open</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableRows} {/* Ersetzen Sie 'YourSettingName' durch den tatsächlichen Namen des Settings */}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Button variant="contained" color="primary" onClick={handleGetFeedbacks} className={classes.button}>Get Feedback</Button>
                </Paper>

            </TabPanel>
            
            <TabPanel className={classes.tabPanel} value={value} index={3}>
                <Paper className={classes.paper}>
                    <Typography className={classes.text} variant="h6">Database Settings</Typography>
                    <Button variant="contained" color="primary" onClick={handleUpdateAllTerms} className={classes.button}>Update All Terms</Button>
                    <Button variant="contained" color="primary" onClick={handleResetAbbreviation} className={classes.button}>Reset All Abbs</Button>
                    <Button variant="contained" color="red" onClick={handleRemoveAllTerms} className={classes.button}>Delete All Terms</Button>
                    <Button variant="contained" color="red" onClick={handleRemoveAllLinks} className={classes.button}>Delete All Links</Button>
                    <Button variant="contained" color="red" onClick={handleRemoveAllAutoLinks} className={classes.button}>Delete All Auto Links</Button>
                    <TextField
                        name="delete"
                        value={deleteCode}
                        onChange={event => handleChangeDeleteCode(event, deleteCode)}
                        id="standard-basic"
                        label="Insert delete code"
                        className={clsx(classes.input, classes.margin)}
                        variant="outlined"
                        size="small"
                    />
                </Paper>
            </TabPanel>

            <Snackbar
                open={openAlert}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                message="Note archived"
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert onClose={handleSnackbarClose} severity="success">
                    User has bin Created and added to the Groupe!
                </Alert>
            </Snackbar>


            <DetailFeedbackDialog
                handleFeedbackDialogClose={handleFeedbackDialogClose}
                feedbackDialogOpen={feedbackDialogOpen}
                feedback={currentFeedback}
            />

        </Container>
    )

}
